import base64 from 'base-64'

const utils = {
	decode(dataStr) {
		try {
			if (typeof dataStr !== "string") {
				throw new Error("Data invalid.")
			}
			let dataBase64 = base64.decode(dataStr)
			return decodeURIComponent(dataBase64)
		} catch (error) {
			return ""
		}
	},
	encode(dataStr) {
		try {
			if (typeof dataStr !== "string") {
				throw new Error("Data invalid.")
			}
			let dataUTF8 = encodeURIComponent(dataStr)
			return base64.encode(dataUTF8)
		} catch (error) {
			console.error(error)
			return ""
		}
	},
	arrayDiff(arrayA, arrayB) {
		if (!Array.isArray(arrayA)) {
			return []
		}
		if (!Array.isArray(arrayB)) {
			return arrayA
		}

		return arrayA.filter(a => {
			let b = arrayB.find(b => b === a)
			return !b
		})
	},
}

export default utils


// WEBPACK FOOTER //
// ./src/core/utility/utils.js